import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export default class SingleDoctorSlider {
  constructor(swiperWrapper) {
    this.wrapper = swiperWrapper;

    this.initSlider();
  }

  initSlider = () => {
    new Swiper(this.wrapper, {
      slidesPerView: 1,
      navigation: {
        nextEl: ".doctor-next-button",
        prevEl: ".doctor-prev-button",
      },
      breakpoints: {
        590: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  };
}
